import { getApiBaseUrl } from '../utils/urls';

export function postLogin(username, password) {
  return fetch(`${getApiBaseUrl()}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ username, password }),
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Unauthorized');
    }

    return response.json();
  });
}

export function postSignup(username, password) {
  return fetch(`${getApiBaseUrl()}/signup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password }),
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Not authenticated');
    }

    return response.json();
  });
}

export function fetchUserInfo() {
  return fetch(`${getApiBaseUrl()}/user-info`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Not authenticated');
    }

    return response.json();
  });
}

export function postLogout() {
  return fetch(`${getApiBaseUrl()}/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Logout failed');
    }

    return response.json();
  });
}
